import * as React from 'react';
import {
    ListItem,
    ListItemText,
    Link as MuiLink,
} from '@mui/material';
import { Link } from 'react-router-dom';
import {
    useCreatePath,
    useRecordContext,
} from 'react-admin';

import { BackInStock } from '../types';

export const BackInStockItem = () => {
    const record = useRecordContext<BackInStock>();
    const createPath = useCreatePath();
    if (!record) {
        return null;
    }
    return (
        <MuiLink
            to={createPath({
                resource: 'back-in-stock',
                type: 'edit',
                id: record.id,
            })}
            component={Link}
            underline="none"
            color="inherit"
        >
            <ListItem>
                <ListItemText
                    primary={record.email}
                    secondary={record.productName}
                    secondaryTypographyProps={{ noWrap: true }}
                />
            </ListItem>
        </MuiLink>
    );
};
